import React, { useEffect, useState } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../config/msalConfig';

// Create MSAL instance only once - use global to prevent React strict mode issues
declare global {
  interface Window {
    msalInstance?: PublicClientApplication;
  }
}

const getMsalInstance = (): PublicClientApplication => {
  if (!window.msalInstance) {
    console.log('Creating new MSAL instance');
    window.msalInstance = new PublicClientApplication(msalConfig);
  }
  return window.msalInstance;
};

interface MsalAuthProviderProps {
  children: React.ReactNode;
}

export const MsalAuthProvider: React.FC<MsalAuthProviderProps> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        const instance = getMsalInstance();
        await instance.initialize();
        setIsInitialized(true);
        console.log('MSAL initialized successfully');
      } catch (error) {
        console.error('Failed to initialize MSAL:', error);
        setIsInitialized(true); // Still render children to show error
      }
    };

    initializeMsal();
  }, []);

  if (!isInitialized) {
    return <div>Initializing authentication...</div>;
  }

  return (
    <MsalProvider instance={getMsalInstance()}>
      {children}
    </MsalProvider>
  );
};

export default MsalAuthProvider;
